import { useContext } from 'react';
import ToggleButtonGroupContext, {
  IToggleButtonGroupContext,
} from './ToggleButtonGroupContext';

const useToggleButtonGroup: () => IToggleButtonGroupContext = () =>
  useContext(ToggleButtonGroupContext);

export default useToggleButtonGroup;
